interface BoxWithGearSVGProps {
  color: string;
  style: React.CSSProperties;
}

const BoxWithGearSVG = ({ color, style }: BoxWithGearSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="47"
    height="50"
    viewBox="0 0 47 50"
    fill="none"
  >
    <g clipPath="url(#clip0_465_6152)">
      <path
        d="M14.3699 17.8845C14.6499 13.1027 18.4499 9.32324 23.0999 9.32324C27.7499 9.32324 31.6399 13.1967 31.8399 18.062"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.26 18.0411C36.26 18.0411 36.26 17.9994 36.26 17.9681C36.26 15.953 36.96 14.0006 38.3 12.539L38.96 11.829L36.16 6.7653L35.24 7.00544C33.36 7.49615 31.39 7.16205 29.72 6.13887L29.66 6.10755C27.98 5.09481 26.7 3.48696 26.16 1.53457L25.9 0.584473H20.3L20.04 1.53457C19.5 3.47652 18.23 5.09481 16.55 6.10755C16.55 6.10755 16.53 6.10755 16.53 6.11799C16.53 6.11799 16.51 6.11799 16.5 6.12843C14.82 7.14116 12.85 7.4857 10.96 6.995L10.04 6.75486L7.23999 11.8185L7.89999 12.5285C9.24999 13.9902 9.94999 15.953 9.94999 17.9785C9.94999 17.9994 9.94999 18.0203 9.94999 18.0516"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.4102 16.1826H28.6402"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.4102 18.939H28.6402"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.4102 21.7061H28.6402"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5701 18.939H18.7901"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5701 21.7061H18.7901"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.75 23.439V24.7232"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.1001 23.439V24.7232"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.46 23.439V24.7232"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.75 13.1655V14.4393"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.1001 13.1655V14.4393"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.5201 16.1826C22.5201 17.4042 21.5701 18.4065 20.3901 18.4065V21.7057H25.6801V16.1826H22.5201Z"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.36 20.0249L26.5 27.7718"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.6701 27.7614L6.8501 20.0249"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.3601 31.2276V39.6219L34.8801 42.326L23.1001 49.4151L6.8501 39.6219V30.9771"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.1001 34.0361V42.8376"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.3601 20.0249L45.6501 23.8253L29.4001 33.6186L23.1001 29.8286"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.85006 20.0249L0.560059 23.8253L16.8101 33.6186L23.1001 29.8286"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_465_6152">
        <rect width="46.21" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default BoxWithGearSVG;
